import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/appServices/DataService/data.service';



@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  constructor(public dataService : DataService) { }

  ngOnInit(): void {
  }

  BacktoDashboard(){
    window.location.href = '/Dashboard';
  }

}
